// @flow
import * as React from 'react';
import styled from 'styled-components';
import Modal from 'react-modal';

// https://github.com/styled-components/styled-components/issues/1494
// https://github.com/reactjs/react-modal/issues/603
function ReactModalAdapter({ className, modalClassName, ...props }) {
  return (
    <Modal className={modalClassName} portalClassName={className} {...props} />
  );
}

const StyledModal = styled(ReactModalAdapter).attrs({
  overlayClassName: 'Overlay',
  modalClassName: 'Modal'
})`
  .Overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(60, 59, 59, 0.75);
    z-index: 2000;
  }

  .Modal {
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 0.25rem;
    bottom: auto;
    left: 50%;
    min-height: 10rem;
    min-width: 20rem;
    max-width: ${props => props.maxWidth ? props.maxWidth : '20rem'};
    padding: 1rem;
    position: fixed;
    right: auto;
    text-align: center;
    top: 50%;
    transform: translate(-50%, -50%);
    outline: none;

    > h1 {
      font-size: 30px;
      margin: 1rem 0;
    }
  }
`;

export default StyledModal;
